import { isEmpty } from 'lodash';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerUserApprovalService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CustomerUserDto,
} from '../../services/wealthlane-customer-services';
import { type TableParamsType } from '../../types/common';

const useGetCustomerUserApprovalList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
  // isEnabled?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CustomerUserDto | undefined,
  unknown
> => {
  // const {
  //   approvalStatusId,
  //   userStatus: isEnabled,
  //   filter,
  //   sorting,
  //   skipCount,
  //   maxResultCount,
  // } = tableInfo;
  const {
    approvalStatusId,
    userStatus: isEnabled,
    filter,
    sorting,
    skipCount,
    maxResultCount,
    _force,
  } = tableInfo;

  const getCustomerUserCustomerUserApprovalList = useQuery(
    [
      'getCustomerUserCustomerUserApprovalList',
      approvalStatusId,
      isEnabled,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      // if (status === 5) {
      //   status = undefined;
      // }
      return await handleRequest(
        CustomerUserApprovalService.getApiCustomerApiAppCustomerUserApprovalCustomerUserList(
          !isEmpty(approvalStatusId) ? approvalStatusId : [0],
          isEnabled,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
    // {
    //   keepPreviousData: true,
    // }
  );
  return getCustomerUserCustomerUserApprovalList;
};

export default useGetCustomerUserApprovalList;
